import { Component , AfterViewInit, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls : ['./agents.component.css']
})
export class AgentsComponent implements OnInit ,AfterViewInit{

  constructor(public shared: SharedService){
    this.shared.isWhiteMenu = false;
  }

  ngOnInit(): void {
      
  }

  ngAfterViewInit(): void {
      this.shared.includeMainScript();
  }
}
